/* Backorder-melding — productpagina + winkelwagen.
 *
 * Verschijnt zodra de klant in de qty-selector méér kiest dan er van de gekozen
 * variant op voorraad ligt. Het exacte voorraadgetal komt uit de tekst van het
 * metaveld web.stock_info ("Nog 4 op voorraad") — de enige plek waar het getal in
 * Shopify staat (web.stock_qty is leeg). Werkt daarom voor de lage band (1-9); bij
 * 10+ staat er geen getal en kan er niet gewaarschuwd worden.
 *
 * Nabesteld = de hele bestelling krijgt de nabestel-levertijd: minimaal 14 werkdagen
 * i.p.v. 2-4 werkdagen.
 *
 * ROBUUSTHEID: alles loopt via event-delegatie op naam="quantity" (niet op id — de
 * calculator rendert soms twee #product-quantity-input) en via een MutationObserver
 * op nieuw ingeladen winkelwagen-regels, zodat AJAX-herrenders (drawer/cart) ook
 * meegenomen worden.
 */
(function () {
  if (window.__vmBackorderInit) return;
  window.__vmBackorderInit = true;

  /* Exact voorraadgetal uit "Nog X op voorraad"; null als er geen getal in staat. */
  function stockFromInfo(info) {
    if (!info || info === 'null') return null;
    var m = /nog\s+(\d+)\s+op\s+voorraad/i.exec(info);
    return m ? parseInt(m[1], 10) : null;
  }

  function injectCss() {
    if (document.getElementById('vm-backorder-css')) return;
    var css =
      '.vm-backorder-notice{gap:10px;align-items:flex-start;background:#FFF7ED;border:1.5px solid #FED7AA;border-radius:4px;padding:12px 14px;margin:0;}' +
      '.vm-backorder-notice[hidden]{display:none;}' +
      '.vm-backorder-notice:not([hidden]){display:flex;}' +
      '.vm-backorder-notice > svg{color:#EA580C;flex-shrink:0;margin-top:1px;}' +
      '.vm-backorder-notice__body{display:flex;flex-direction:column;gap:2px;font-size:13px;line-height:1.45;color:#7C2D12;}' +
      '.vm-backorder-notice__body strong{color:#9A3412;font-weight:700;}' +
      '.cart-item .vm-backorder-notice{margin-top:8px;}';
    var s = document.createElement('style');
    s.id = 'vm-backorder-css';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  /* Zet de melding aan/uit voor één notice-element. factor = stuks per voorraadeenheid
   * (matten op maat: voorraad in meters, aantal in stukken van 10 cm → 10). */
  function setNotice(notice, stock, qty, factor) {
    if (!qty || qty < 1) qty = 1;
    if (stock !== null && stock >= 1 && qty > stock * (factor || 1)) {
      var el = notice.querySelector('[data-vm-backorder-stock]');
      if (el) el.textContent = stock;
      notice.hidden = false;
    } else {
      notice.hidden = true;
    }
  }

  /* ── Productpagina ──────────────────────────────────────────── */
  function initProduct() {
    var notice = document.getElementById('vm-backorder-notice');
    if (!notice) return;
    var map = window.__vmStockInfo || {};
    var form = notice.closest('form') || document;
    var variantSel = document.querySelector('[data-variant-selection]');
    var idInput = form.querySelector('[data-variants]');
    var factor = parseFloat(notice.getAttribute('data-vm-stock-factor')) || 1;

    /* Hoogste ingevoerde aantal over alle quantity-velden (de calculator toont er soms twee). */
    function currentQty() {
      var q = 0, ins = form.querySelectorAll('input[name="quantity"]');
      for (var i = 0; i < ins.length; i++) {
        var v = parseInt(ins[i].value, 10);
        if (isFinite(v) && v > q) q = v;
      }
      return q || 1;
    }
    function currentStock() {
      var vid = variantSel ? variantSel.getAttribute('variant') : null;
      if (!vid || vid === 'not-selected') vid = idInput ? idInput.value : null;
      return (vid != null && map[vid] != null) ? stockFromInfo(map[vid]) : null;
    }
    function evaluate() { setNotice(notice, currentStock(), currentQty(), factor); }

    /* Delegatie op de form: vangt typen in élk quantity-veld (dubbele id's) . */
    form.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') evaluate(); });
    form.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') evaluate(); });
    /* +/- knoppen zetten de waarde programmatisch (geen input-event) → na de klik opnieuw checken. */
    form.addEventListener('click', function (e) {
      if (e.target.closest('.input-extra-button, [data-type], #input-plus-btn, #input-minus-btn, #unit-plus-btn, #unit-minus-btn')) {
        setTimeout(evaluate, 0);
      }
    });
    if (idInput) idInput.addEventListener('change', evaluate);
    /* De rekenhulp zet het aantal programmatisch; dit event komt na elke herberekening
     * (ook bij typen in het meterveld, waar #calc-total-line bij unit=meter niet meebeweegt). */
    document.addEventListener('vm:calc-update', evaluate);
    if (window.MutationObserver) {
      var calcLine = document.getElementById('calc-total-line');
      if (calcLine) new MutationObserver(evaluate).observe(calcLine, { childList: true, characterData: true, subtree: true });
      if (variantSel) new MutationObserver(evaluate).observe(variantSel, { attributes: true, attributeFilter: ['variant'] });
    }
    evaluate();
  }

  /* ── Winkelwagen (delegatie + observer → AJAX-bestendig) ─────── */
  function cartNoticeInLine(el) {
    var line = el.closest ? el.closest('.cart-item') : null;
    return line ? line.querySelector('[data-vm-cart-backorder]') : null;
  }
  function evalCartNotice(notice) {
    var line = notice.closest('.cart-item');
    var input = line ? line.querySelector('input[name="quantity"]') : null;
    var qty = input ? parseInt(input.value, 10) : 1;
    setNotice(notice, stockFromInfo(notice.getAttribute('data-stock-info')), qty);
  }
  function initCart() {
    var notices = document.querySelectorAll('[data-vm-cart-backorder]');
    for (var i = 0; i < notices.length; i++) evalCartNotice(notices[i]);
  }
  function wireCartDelegation() {
    function onQty(e) {
      if (!e.target || e.target.name !== 'quantity') return;
      var n = cartNoticeInLine(e.target);
      if (n) evalCartNotice(n);
    }
    document.addEventListener('input', onQty);
    document.addEventListener('change', onQty);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('cart-quantity-input [data-type]')) {
        var n = cartNoticeInLine(e.target);
        if (n) setTimeout(function () { evalCartNotice(n); }, 0);
      }
    });
    /* AJAX-toegevoegde/-vervangen winkelwagen-regels. */
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            var nd = muts[i].addedNodes[j];
            if (!nd || nd.nodeType !== 1) continue;
            if (nd.matches && nd.matches('[data-vm-cart-backorder]')) evalCartNotice(nd);
            if (nd.querySelectorAll) {
              var found = nd.querySelectorAll('[data-vm-cart-backorder]');
              for (var k = 0; k < found.length; k++) evalCartNotice(found[k]);
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function init() {
    injectCss();
    initProduct();
    initCart();
    wireCartDelegation();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

